import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../components/forms/Card";
import FormGroup from "../../components/forms/FormGroup";
import Input from "../../components/forms/FormEl";
import {Col, Row} from "../../components/flex/FlexLayout";
import Button from "../../components/forms/Button";
import ConsejerosFormSelect from "../../components/selects/ConsejerosFormSelect";
const HorarioForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm(
    {defaultValues: value}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  return (
    <form>
      <Card padding>

        <FormGroup>
          <label>Consejero</label>
          <ConsejerosFormSelect {...register("usuarioId", {required: "Campo obligatorio"})}/>
          {errors.usuarioId && <p style={{color: 'red'}}>{errors.usuarioId?.message}</p>}
        </FormGroup>

      </Card>

      <Card padding>

        <Row>
          <Col>
            <FormGroup>
              <label>Fecha inicio</label>
              <Input type={"date"} {...register("fechaInicio", { required: "Campo obligatorio"})}/>
              {errors.fechaInicio && <p style={{color: 'red'}}>{errors.fechaInicio?.message}</p>}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <label>Fecha fin</label>
              <Input type={"date"} {...register("fechaFin", { required: "Campo obligatorio"})}/>
              {errors.fechaFin && <p style={{color: 'red'}}>{errors.fechaFin?.message}</p>}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <label>Hora inicio</label>
              <Input type={"time"} {...register("horaInicio", { required: "Campo obligatorio"})}/>
              {errors.horaInicio && <p style={{color: 'red'}}>{errors.horaInicio?.message}</p>}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <label>Hora fin</label>
              <Input type={"time"} {...register("horaFin", { required: "Campo obligatorio"})}/>
              {errors.horaFin && <p style={{color: 'red'}}>{errors.horaFin?.message}</p>}
            </FormGroup>
          </Col>
        </Row>
      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default HorarioForm;
